import React from 'react'
import { twMerge } from 'tailwind-merge'
import { FormElementMenuItem } from '../form-elements-menu-item'

interface FormAddNewElementSettingsItemProps
  extends Omit<React.LiHTMLAttributes<HTMLLIElement>, 'onChange'> {
  title: string
  icon?: () => React.ReactNode
  controlComponent: () => React.ReactNode
}

export const FormAddNewElementSettingsItem = ({
  className,
  title,
  icon,
  controlComponent,
  ...props
}: FormAddNewElementSettingsItemProps) => {
  return (
    <li
      className={twMerge(
        'flex min-h-9 w-full items-center justify-between rounded-md px-0.5',
        className,
      )}
      {...props}
    >
      <FormElementMenuItem title={title} icon={icon} />
      {controlComponent()}
    </li>
  )
}
